<template>
  <div class="product-documentation-spinner">
    <div class="product-documentation-spinner__roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>